import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class HttpsInterceptor implements HttpInterceptor {
  constructor() {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hasProtocol = req.url?.startsWith('http://') || req.url?.startsWith('https://');

    if (!req.url?.endsWith('.svg') && !hasProtocol) {
      const url = req.body?.serverD ? `${environment.WsBaseUrl}` : `${environment.BaseUrl}`;

      req = req.clone({
        url: url + req.url,
      });
    }
    return next.handle(req).pipe();
  }
}
